import { render, staticRenderFns } from "./EditTrustPhotos.vue?vue&type=template&id=3c29461d&"
import script from "./EditTrustPhotos.vue?vue&type=script&lang=js&"
export * from "./EditTrustPhotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports